import { React, useEffect, useState } from "react";
import { InformationsWrapper } from "../customersPage.styled";
import TransactionsHeader from "../Partials/TransactionsHeader";
import { TransactionsCells, UpcomingPaymentCells } from "../data";
import CustomersTable from "./customersTable";
import { getTransactionHistory, getUpcomingPayments } from "../customersUtils";
import { toast } from "react-toastify";
import { Backdrop, CircularProgress } from "@mui/material";
import { useParams } from "react-router";

function Transactions() {
	const { id } = useParams();
	// eslint-disable-next-line no-unused-vars
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(true);
	const [headCells, setHeadCells] = useState(TransactionsCells);
	const [tab, setTab] = useState("transactions");
	const [paymentsData, setPaymentsData] = useState();
	const [selected, setSelected] = useState([]);

	//get history and payments on load of transactions
	useEffect(() => {
		getTransactionHistory(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else if (res.result) {
					setLoading(false);
					// console.log(res.result);
					let updatedData = res?.result?.map((data) => {
						return { ...data, ...data.productId, objectId: data.objectId };
					});
					// console.log(updatedData)
					setData(updatedData);
				} else {
					setLoading(false);
					toast.error("Unable to fetch transactions history");
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(
					"Unable to reach server, please check your internet connection"
				);
			});

		getUpcomingPayments(id)
			.then((res) => {
				if (res.error) {
					toast.error(res.error);
				} else if (res.result) {
					setPaymentsData(res.result);
				} else {
					toast.error("Unable to fetch Upcoming payments");
				}
			})
			.catch((error) => {
				console.log(error);
				toast.error(
					"Unable to reach server, please check your internet connection"
				);
			});
	}, []);

	//get upcoming payments onclick of upcoming payments
	const handlePayments = () => {
		setHeadCells(UpcomingPaymentCells);
		setData(paymentsData);
		setTab("");
	};

	//get history onclick of go back
	const handleHistoryData = () => {
		setLoading(true);
		setHeadCells(TransactionsCells);
		setTab("transactions");
		getTransactionHistory(id)
			.then((res) => {
				if (res.error) {
					setLoading(false);
					toast.error(res.error);
				} else if (res.result) {
					setLoading(false);
					// console.log(res.result);
					let updatedData = res.result.map((data) => {
						return { ...data, ...data.productId, objectId: data.objectId };
					});
					console.log(updatedData);
					setData(updatedData);
				} else {
					setLoading(false);
					toast.error("Unable to fetch transactions history");
				}
			})
			.catch((error) => {
				setLoading(false);
				console.log(error);
				toast.error(
					"Unable to reach server, please check your internet connection"
				);
			});
	};
	return (
		<InformationsWrapper>
			{tab === "transactions" ? (
				<p className='avatar'>
					<img src='/images/history_img.svg' alt='transaction image' />
				</p>
			) : null}

			<TransactionsHeader
				handlePayments={handlePayments}
				tab={tab}
				handleHistory={handleHistoryData}
			/>
			<CustomersTable
				headCells={headCells}
				TableData={data}
				setSelected={setSelected}
				selected={selected}
			/>
			{loading && (
				<Backdrop
					sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
					open={loading}
				>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</InformationsWrapper>
	);
}

export default Transactions;
